
import { typeIcon } from '@/utils/partnerLocator'

export default {
  name: 'PartnerLocatorSearch',
  props: {
    types: {
      type: Array,
      default: () => [],
    },
    counts: {
      type: Object,
      default: () => ({}),
    },
    total: {
      type: Number,
      default: 0,
    },
    typeId: {
      type: Number,
      default: null,
    },
    value: {
      type: String,
      default: '',
    },
    locating: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: null,
    },
  },
  computed: {
    whereLabel() {
      const label = this.$t('pages.quiSommesNousPartenaires.stepWhere')
      return this.types.length ? label : label.replace(/^\s*\d+\.\s*/, '')
    },
  },
  methods: {
    icon: typeIcon,
    needTitle(type) {
      const key = `pages.quiSommesNousPartenaires.need.${type.identifier}.title`
      return this.$te(key) ? this.$t(key) : type.name
    },
    needText(type) {
      const key = `pages.quiSommesNousPartenaires.need.${type.identifier}.text`
      return this.$te(key) ? this.$t(key) : ''
    },
  },
}
